import formatMessage from 'format-message'
import isEqual from 'lodash/isEqual'

export const isCommentGroupStacked = (isSelected, shouldCommentGroupStack) => {
  return isSelected === false && shouldCommentGroupStack === true
}

export function byCreatedAt(a, b) {
  return new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
}

export function generatePlaceholder(isFirstComment, isAnonymous) {
  if (isFirstComment && isAnonymous) {
    return formatMessage('Leave anonymous comment')
  } else if (isFirstComment) {
    return formatMessage('Leave a comment')
  } else if (isAnonymous) {
    return formatMessage('Leave anonymous reply')
  } else {
    return formatMessage('Leave a reply')
  }
}

export function areEqual(prevProps, nextProps) {
  if (nextProps.isVisible === false && prevProps.managedTop != null) {
    return true
  }

  return (
    nextProps.isSelected === prevProps.isSelected &&
    nextProps.isVisible === prevProps.isVisible &&
    nextProps.managedTop === prevProps.managedTop &&
    nextProps.annotation.modified_at === prevProps.annotation.modified_at &&
    isEqual(nextProps.commentReplies, prevProps.commentReplies) &&
    nextProps.shouldCommentGroupStack === prevProps.shouldCommentGroupStack
  )
}
